import _slicedToArray from "/opt/build/repo/apps/ac-dealer-portal/node_modules/.pnpm/@babel+runtime@7.20.13/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _defineProperty from "/opt/build/repo/apps/ac-dealer-portal/node_modules/.pnpm/@babel+runtime@7.20.13/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import React, { useRef, useMemo, useReducer as useReactReducer, createContext as createReactContext, useContext as useReactContext } from "react";
import { useStableMemo } from "../hooks/useStableMemo";
import { makeReduceActions, reduceState } from "./state-actions";
export var createActionHandlers = function createActionHandlers(initialState, actions) {
  return actions;
};
var wrapContextActions = function wrapContextActions(actionHandlers, dispatch) {
  return Object.keys(actionHandlers).reduce(function (acc, key) {
    return Object.assign(acc, _defineProperty({}, key, function (input) {
      dispatch({
        type: key,
        payload: input
      });
    }));
  }, {});
};
var makeContextReducer = function makeContextReducer(actionHandlers, reduceActions) {
  return function (prevState, action) {
    if (actionHandlers.hasOwnProperty(action.type)) {
      var fn = actionHandlers[action.type];
      var newState = fn(action.payload, prevState, reduceActions);
      return reduceState(prevState, newState);
    }
    return prevState;
  };
};
var useContextReducer = function useContextReducer(defaultState, actionHandlers) {
  var useActionHandlers = useRef(actionHandlers);
  var reducerFn = useStableMemo(function () {
    return makeContextReducer(useActionHandlers.current, makeReduceActions());
  }, []);
  var _useReactReducer = useReactReducer(reducerFn, defaultState),
    _useReactReducer2 = _slicedToArray(_useReactReducer, 2),
    state = _useReactReducer2[0],
    dispatch = _useReactReducer2[1];
  var actions = useStableMemo(function () {
    return wrapContextActions(useActionHandlers.current, dispatch);
  }, [dispatch]);
  return [state, actions];
};
export var createContext = function createContext(name, defaultState, actionHandlers) {
  var ReactContext = createReactContext({});
  function useContext() {
    var context = useReactContext(ReactContext);
    if (!context) {
      throw new Error(["You cannot use '".concat(name, "' Context from outside of its"), "<Provider> element"].join(" "));
    }
    return context;
  }
  var ContextProvider = function ContextProvider(_ref) {
    var children = _ref.children;
    var _useContextReducer = useContextReducer(defaultState, actionHandlers),
      _useContextReducer2 = _slicedToArray(_useContextReducer, 2),
      state = _useContextReducer2[0],
      actions = _useContextReducer2[1];
    var providerValue = useMemo(function () {
      return {
        state: state,
        actions: actions
      };
    }, [state, actions]);
    return React.createElement(ReactContext.Provider, {
      value: providerValue
    }, children);
  };
  return [ContextProvider, useContext];
};